import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import { CategoryManagement } from './components/CategoryManagement';

const EdutainmentCategoryManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="育樂類別設定及管理"
          breadcrumbs={[
            {
              name: '育樂活動',
            },
            {
              name: '育樂類別設定及管理',
            },
          ]}
        />
        <CategoryManagement />
      </Col>
    </Row>
  );
};

export default EdutainmentCategoryManagement;
